import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./EventsCMS.css";
import rehypeRaw from "rehype-raw";
import { FaTrash } from "react-icons/fa";
import logoo from "../Components/Header/assets/images/logo.png";
import { NavLink } from "react-router-dom";


const EventsCMS = () => {
  const [events, setEvents] = useState([]);
  const [activeTab, setActiveTab] = useState("addEvent");
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    shortDescription: "",
    fullDescription: "",
    image: null,
  });
  const [showInstructions, setShowInstructions] = useState(false);


  const fetchEvents = async () => {
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/events`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEvents(data);
    } catch (error) {
      if(error.response?.status === 401 || error.status === 401){ 
        alert("Unauthorized! Please log in again.");
        handleLogout();
      }
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);
     
const [admins, setAdmins] = useState([]);


  const fetchAdmins = async () => {
  try {
    const token = localStorage.getItem("token");
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/all`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setAdmins(data);
  } catch (error) {
    if(error.response?.status === 401 || error.status === 401){ 
      alert("Unauthorized! Please log in again.");
      handleLogout();
    }
  }
};

useEffect(() => {
  fetchAdmins();
}, []);

const [currentAdmin, setCurrentAdmin] = useState(null);

useEffect(() => {
  const fetchAdmin = async () => {
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/verify-token`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCurrentAdmin(data);
    } catch (error) {
      console.error("Error verifying admin:", error);
    }
  };
  fetchAdmin();
}, []);


const handleDeleteAdmin = async (id) => {
  if (!window.confirm("Are you sure you want to delete this admin?")) return;

  try {
    const token = localStorage.getItem("token");
    await axios.delete(`${process.env.REACT_APP_API_URL}/api/auth/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setAdmins(admins.filter((admin) => admin._id !== id));
  } catch (error) {
    if(error.response?.status === 401 || error.status === 401){
      alert("Unauthorized! Please log in again.");
      handleLogout();
    }


  }
};



  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({ ...prev, [name]: files ? files[0] : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();
    form.append("title", formData.title);
    form.append("shortDescription", formData.shortDescription);
    form.append("fullDescription", formData.fullDescription);
    if (formData.image) form.append("image", formData.image);

    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    if (editingId) {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/events/${editingId}`,
        form,
        config
      );
    } else {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/events/create`,
        form,
        config
      );
    }

    setFormData({
      title: "",
      shortDescription: "",
      fullDescription: "",
      image: null,
    });
    setEditingId(null);
    fetchEvents();
    } catch (error) {
      if(error.response?.status === 401 || error.status === 401){
        alert("Unauthorized! Please log in again.");
        handleLogout();
      }
    
  }
}

  const handleEdit = (event) => {
    setFormData({
      title: event.title,
      shortDescription: event.shortDescription,
      fullDescription: event.fullDescription,
      image: null,

      
    });
    setEditingId(event._id);
    setActiveTab("addEvent");
  };

  const handleDelete = async (id) => {

    try {
        await axios.delete(`${process.env.REACT_APP_API_URL}/api/events/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    fetchEvents();
    } catch (error) {
      if(error.response?.status === 401 || error.status === 401){ 
        alert("Unauthorized! Please log in again.");
        handleLogout();
      }
      
    }
  
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/admin-login";
  };

  const handleCreateAdmin = () => {
    window.location.href = "/create-admin";
  };

  return (
    <div className="cms-dashboard">
      {/* Sidebar */}
      <aside className="cms-sidebar">
        <h2>Admin Panel</h2>
        <button
          className={activeTab === "addEvent" ? "active" : ""}
          onClick={() => setActiveTab("addEvent")}
        >
          ➕ Add Event
        </button>
        <button
          className={activeTab === "history" ? "active" : ""}
          onClick={() => setActiveTab("history")}
        >
          📜 Event History
        </button>
        <button
          className={activeTab === "admins" ? "active" : ""}
          onClick={() => setActiveTab("admins")}
        >
          👤 Admins
        </button>


      </aside>

   


      {/* Main Section */}
      <div className="cms-main">
        <header className="cms-topbar">
          <div> 
             <NavLink to="/">
            <img
              loading="lazy"
              src={logoo}
              alt="Iskcon Vijayawada Logo"
              className="iskcon-logoo"
            />
          </NavLink>
          </div>

          {currentAdmin && (
            <div className="current-admin-banner">
              
               <p>
                
                👋 Logged in as <strong>{currentAdmin.username}</strong>
                
              </p>
            </div>
          )}

          <div className="topbar-right">
            <button onClick={handleCreateAdmin}>Create Admin</button>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </div>
        </header>

        <div className="cms-content">
          {activeTab === "addEvent" && (
            <div className="add-event-section"> 
            <div className="form-section">
              <h2>{editingId ? "Edit Event" : "Add New Event"}</h2>
              <form onSubmit={handleSubmit} className="event-form">
                <input
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  placeholder="Title"
                  required
                />

                <textarea
                  name="shortDescription"
                  value={formData.shortDescription}
                  onChange={handleChange}
                  placeholder="Short Description"
                  required
                />

                
                <div className="markdown-editor">

                    <div className="full-desc-header">
                      
                      <button
                        type="button"
                        className="info-btn"
                        onClick={() => setShowInstructions(!showInstructions)}
                      >
                        🛈 Instructions
                      </button>
                    </div>

                    {showInstructions && (
                      <div className="popup-overlay" onClick={() => setShowInstructions(false)}>
                        <div
                          className="popup-content"
                          onClick={(e) => e.stopPropagation()} // Prevent close on inner click
                        >
                          <div className="popup-header">
                            <h5>Formatting Guide</h5>
                            <span className="close-popup" onClick={() => setShowInstructions(false)}>
                              &#x2715;
                            </span>
                          </div>

                          <div className="popup-body">
                            <p>
                              You can write your full description using <b>Markdown</b> or <b>HTML</b>.
                              This gives you control over <i>headings, paragraphs, bold text, links, images, and more.</i>
                            </p>

                            <hr />

                            <h5>🟢 Headings</h5>
                            <ul>
                              <li><code># Heading 1</code> → <b>Used for main titles</b></li>
                              <li><code>## Heading 2</code> → For sub-titles</li>
                              <li><code>### Heading 3</code> → For smaller section titles</li>
                            </ul>
                            <p><b>HTML Alternative:</b> <code>&lt;h1&gt;Main Heading&lt;/h1&gt;</code></p>

                            <hr />

                            <h5>🔹 Paragraphs</h5>
                            <ul>
                              <li>Just write normally — every blank line creates a new paragraph.</li>
                            </ul>
                            <p><b>HTML Alternative:</b> <code>&lt;p&gt;This is a paragraph.&lt;/p&gt;</code></p>

                            <hr />

                            <h5>💪 Text Formatting</h5>
                            <ul>
                              <li><b>Bold:</b> <code>**bold text**</code> → <b>bold text</b></li>
                              <li><i>Italic:</i> <code>*italic text*</code> → <i>italic text</i></li>
                              <li><b><i>Bold + Italic:</i></b> <code>***bold italic text***</code></li>
                              <li><u>Underline (HTML only):</u> <code>&lt;u&gt;underlined&lt;/u&gt;</code></li>
                            </ul>

                            <hr />

                            <h5>📋 Lists</h5>
                            <ul>
                              <li><b>Unordered List (bullets):</b></li>
                              <code>
                                - Item 1<br />
                                - Item 2<br />
                                - Item 3
                              </code>
                              <li><b>Ordered List (numbers):</b></li>
                              <code>
                                1. Step one<br />
                                2. Step two<br />
                                3. Step three
                              </code>
                            </ul>
                            <p><b>HTML Alternative:</b></p>
                            <code>
                              &lt;ul&gt;<br />
                              &nbsp;&nbsp;&lt;li&gt;Item 1&lt;/li&gt;<br />
                              &nbsp;&nbsp;&lt;li&gt;Item 2&lt;/li&gt;<br />
                              &lt;/ul&gt;
                            </code>

                            <hr />

                            <h5>🔗 Links</h5>
                            <ul>
                              <li>
                                <code>[Visit Google](https://google.com)</code> →
                                <a href="https://google.com" target="_blank" rel="noreferrer">Visit Google</a>
                              </li>
                            </ul>
                            <p><b>HTML Alternative:</b> <code>&lt;a href="https://google.com"&gt;Visit Google&lt;/a&gt;</code></p>

                            <hr />

                            <h5>🖼️ Images</h5>
                            <ul>
                              <li><code>![Alt text](https://example.com/image.jpg)</code></li>
                            </ul>
                            <p><b>HTML Alternative:</b>
                              <code>&lt;img src="https://example.com/image.jpg" alt="Description" /&gt;</code>
                            </p>

                            <hr />

                            <h5>💬 Blockquotes</h5>
                            <ul>
                              <li><code>&gt; This is a quote line</code></li>
                            </ul>
                            <blockquote>This is a quote line</blockquote>
                            <p><b>HTML Alternative:</b>
                              <code>&lt;blockquote&gt;This is a quote&lt;/blockquote&gt;</code>
                            </p>

                            <hr />

                            <h5>💡 Code or Inline Text</h5>
                            <ul>
                              <li><code>`const name = "John"`</code> → Displays inline code style</li>
                            </ul>
                            <p><b>HTML Alternative:</b> <code>&lt;code&gt;const x = 10;&lt;/code&gt;</code></p>

                            <hr />

                            <h5>📏 Horizontal Line</h5>
                            <ul>
                              <li><code>---</code> or <code>***</code> → Adds a line break</li>
                            </ul>
                            <p><b>HTML Alternative:</b> <code>&lt;hr /&gt;</code></p>

                            <hr />

                            <h5>⚡ Combining Markdown + HTML</h5>
                            <p>You can mix both formats together, e.g.:</p>
                            <code>
                              # Welcome<br />
                              This is **bold**, and this is &lt;i&gt;italic&lt;/i&gt;.
                            </code>

                            <p style={{ marginTop: "10px" }}>
                              <b>✅ Tip:</b> Markdown is simple to write; HTML gives more design control.
                              Use whichever you prefer — both will render beautifully in the Event Details page.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}

                  <textarea
                    placeholder=" Full Description 
                    Use Markdown — e.g. # Heading, **bold**, - list"
                    value={formData.fullDescription}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        fullDescription: e.target.value,
                      })
                    }
                    rows="12"
                    className="markdown-input"
                  />
                 
                </div>

                <input
                  type="file"
                  name="image"
                  onChange={handleChange}
                  accept="image/*"
                />
                  <div className="form-buttons">
                    <button type="submit">
                      {editingId ? "Update Event" : "Add Event"}
                    </button>

                    {editingId && (
                      <button
                        type="button"
                        className="cancel-btn"
                        onClick={() => {
                          setEditingId(null);
                          setFormData({
                            title: "",
                            shortDescription: "",
                            fullDescription: "",
                            image: null,
                          });
                          setActiveTab("history");
                        }}
                      >
                        Cancel Edit
                      </button>
                    )}
                  </div>

              </form>
            </div>
           <div className="markdown-preview">
                    <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                      {formData.fullDescription || "*Live preview...*"}
                    </ReactMarkdown>
                  </div>
            </div>
          )}

          {activeTab === "history" && (
            <div className="event-history">
              <h2>Uploaded Events</h2>
              <div className="event-grid">
                {events.map((event) => (
                  <div className="event-card" key={event._id}>
                    <img src={event.image} alt={event.title} />
                    <h3>{event.title}</h3>
                    <p>{event.shortDescription}</p>

                    {/* New Info Section */}
                    <div className="event-meta">
                      <p><strong>Created By:</strong> {event.createdBy || "Unknown"}</p>
                      <p><strong>Created At:</strong> {new Date(event.createdAt).toLocaleString()}</p>
                    </div>

                    <div className="event-buttons">
                      <button onClick={() => handleEdit(event)}>Edit</button>
                      <button onClick={() => handleDelete(event._id)}>Delete</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          
          {activeTab === "admins" && (
            <div className="admin-tab">
              <h2>All Admins</h2>
              <div className="admin-list-container">
                {admins.length === 0 ? (
                  <p>No admins found.</p>
                ) : (
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>Username</th>
                        <th>Created By</th>
                        <th>Created On</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {admins.map((admin) => (
                        <tr key={admin._id}>
                          <td>{admin.username}</td>
                          <td>{admin.createdBy || "N/A"}</td>
                          <td>{new Date(admin.createdAt).toLocaleString()}</td>
                          <td>
                            <button
                              className="delete-admin-btn"
                              onClick={() => handleDeleteAdmin(admin._id)}
                              title="Delete Admin"
                            >
                                <FaTrash className="trash-icon" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}



        </div>
      </div>
    </div>
  );
};

export default EventsCMS;

